import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('coefficienti');
export const actions = helper.createActions('coefficienti', actionTypes);